<div class="overview-wrapper">
  <!-- Enhanced Header Section -->
  <div class="template-header">
    <div class="header-content">
      <h1 class="template-title">Overview</h1>
      <p class="template-description">
        View server statistics, usage limits, and upcoming events at a glance.
      </p>
    </div>
  </div>

  <!-- Statistics Section -->
  <div class="settings-section">
    <div class="section-header ">
      <h2 class="section-title">Statistics</h2>
      <mat-icon class="section-icon">trending_up</mat-icon>
    </div>
    <div class="row pt-2 justify-content-md-center text-center">
      <div class="col-md-12 col-lg-6 d-flex justify-content-center ">
        <mat-card class="overview-card events-card">
          <mat-card-header class="">
            <mat-card-title-group>
              <mat-card-title>
                <fa-icon [icon]="faIcons.calendarCheck" class="m-auto"></fa-icon>
                Events Created
              </mat-card-title>
              <mat-card-subtitle class="">Total</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
            {{overview.events_created}}
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-12 col-lg-6 d-flex justify-content-center">
        <mat-card class="overview-card user-card">
          <mat-card-header class="">
            <mat-card-title-group>
              <mat-card-title>
                <fa-icon [icon]="faIcons.users" class="m-auto"></fa-icon>
                User Sign Ups
              </mat-card-title>
              <mat-card-subtitle>Total</mat-card-subtitle>
            </mat-card-title-group>
          </mat-card-header>
          <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
            {{overview.user_signups}}
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- Limits Section -->
  <div class="settings-section">
    <div class="section-header">
      <h2 class="section-title">Limits</h2>
      <mat-icon class="section-icon">data_usage</mat-icon>
    </div>
    
    <!-- Premium Info Banner -->
    <div class="premium-info-banner" *ngIf="guild && (guild.has_premium || guild.lifetime_premium)">
      <div class="info-banner-content">
        <mat-icon class="info-banner-icon">info</mat-icon>
        <div class="info-banner-text">
          <strong>Premium Active</strong>
          <p>Limits do not apply while Premium is active. You have unlimited access to all features.</p>
        </div>
      </div>
    </div>
    
    <div class="row justify-content-center pt-2">
    <div class="col-md-12 col-xl-6 col-lg-6 mt-3 mt-xl-0 d-flex justify-content-center">
      <mat-card class="overview-card channel-card">
        <mat-card-header class="">
          <mat-card-title-group>
            <mat-card-title>
              <fa-icon [icon]="faIcons.list" class="m-auto"></fa-icon>
              Event Channels
            </mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
          {{overview.usage.curr_event_channels}} / {{overview.limits.max_event_channels}}
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-12 col-xl-6 col-lg-6 mt-3 mt-xl-0 d-flex justify-content-center">
      <mat-card class="overview-card repeating-entries-card">
        <mat-card-header class="">
          <mat-card-title-group>
            <mat-card-title>
              <fa-icon [icon]="faIcons.repeat" class="m-auto"></fa-icon>
              Repeating Events
            </mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
          {{overview.usage.curr_repeating_events}} / {{overview.limits.max_repeating_events}}
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-12 col-xl-6 col-lg-6 mt-3 mt-xl-3 d-flex justify-content-center">
      <mat-card class="overview-card signup-templates-card">
        <mat-card-header class="">
          <mat-card-title-group>
            <mat-card-title>
              <fa-icon [icon]="faIcons.users" class="m-auto"></fa-icon>
              Signup Templates
            </mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
          {{overview.usage.curr_signup_templates}} / {{overview.limits.max_custom_templates}}
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-12 col-xl-6 col-lg-6 mt-3 mt-xl-3 d-flex justify-content-center">
      <mat-card class="overview-card repeating-entries-card">
        <mat-card-header class="">
          <mat-card-title-group>
            <mat-card-title>
              <fa-icon [icon]="faIcons.calendaPlus" class="m-auto"></fa-icon>
              Event Templates
            </mat-card-title>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content *ngIf="overview$ | async as overview else defaultCount">
          {{overview.usage.curr_event_templates}} / {{overview.limits.max_event_templates}}
        </mat-card-content>
      </mat-card>
    </div>
    </div>
  </div>

  <!-- Upcoming Events Section -->
  <div class="settings-section">
    <div class="section-header section-header-with-actions">
      <div class="section-title-group">
        <h2 class="section-title">Upcoming Events</h2>
        <mat-icon class="section-icon">event</mat-icon>
      </div>
      <ng-container *ngIf="guild?.has_premium">
        <div class="view-controls">
          <div class="view-toggle btn-group" role="group">
            <button type="button" class="btn btn-view"
                    [class.btn-view-active]="viewMode === 'list'"
                    (click)="setViewMode('list')" aria-label="List view">
              <fa-icon [icon]="faIcons.list"></fa-icon>
              <span class="btn-view-label">List</span>
            </button>
            <button type="button" class="btn btn-view"
                    [class.btn-view-active]="viewMode === 'calendar'"
                    (click)="setViewMode('calendar')" aria-label="Calendar view">
              <fa-icon [icon]="faIcons.calendar"></fa-icon>
              <span class="btn-view-label">Calendar</span>
            </button>
          </div>
          <button type="button" class="btn btn-refresh" (click)="refreshOverview()" matTooltip="Refresh schedule" aria-label="Refresh">
            <fa-icon [icon]="faIcons.refresh"></fa-icon>
            <span class="btn-refresh-label">Refresh</span>
          </button>
          <button *ngIf="guild?.organizer || guild?.owner" type="button" class="btn btn-new-schedule" (click)="navigateToNewSchedule()">
            <fa-icon [icon]="faIcons.calendaPlus"></fa-icon>
            <span>New Schedule</span>
          </button>
        </div>
      </ng-container>
    </div>

    <!-- Premium Users - List View -->
    <ng-container *ngIf="guild?.has_premium && viewMode === 'list'">
      <ng-container *ngIf="conflicts$ | async as conflicts">
      <div *ngIf="overview$ | async as overview" class="upcoming-events-container">
        <mat-table [dataSource]="overview.upcoming_events" class="events-table mat-elevation-z8" *ngIf="overview.upcoming_events && overview.upcoming_events.length > 0">
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef>Title</mat-header-cell>
            <mat-cell *matCellDef="let event"><a class="mat-select-link" href="https://discord.com/channels/{{guildId}}/{{event.channel_id}}/{{event.message_id}}" target="_blank">{{ event.title }}</a></mat-cell>
          </ng-container>
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
            <mat-cell *matCellDef="let event">{{ event.start }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="sign_ups">
            <mat-header-cell *matHeaderCellDef>Sign Ups</mat-header-cell>
            <mat-cell *matCellDef="let event">{{ event.sign_ups }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="signed_up">
            <mat-header-cell *matHeaderCellDef>Signed Up</mat-header-cell>
            <mat-cell *matCellDef="let event">
              <fa-icon *ngIf="event.signed_up" [icon]="faIcons.check" class="m-auto check_green"></fa-icon>
              <fa-icon *ngIf="!event.signed_up" [icon]="faIcons.cross" class="m-auto check_red"></fa-icon>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="conflict">
            <mat-header-cell *matHeaderCellDef>Conflict</mat-header-cell>
            <mat-cell *matCellDef="let event">
              <span *ngIf="hasConflict(event, conflicts)" class="conflict-badge" [matTooltip]="getConflictList(event, conflicts)">
                <mat-icon>warning</mat-icon>
              </span>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="['title', 'date', 'sign_ups', 'signed_up', 'conflict']"></mat-header-row>
          <mat-row *matRowDef="let event; columns: ['title', 'date', 'sign_ups', 'signed_up', 'conflict']"></mat-row>
        </mat-table>
        <div class="empty-state" *ngIf="!overview.upcoming_events || overview.upcoming_events.length === 0">
          <mat-icon class="empty-state-icon">event_busy</mat-icon>
          <p class="empty-state-text">No upcoming events scheduled</p>
        </div>
      </div>
      </ng-container>
    </ng-container>

    <!-- Premium Users - Calendar View -->
    <ng-container *ngIf="guild?.has_premium && viewMode === 'calendar'">
      <div class="calendar-view-container">
        <div class="calendar-month-header">
          <h3 class="calendar-month-title">{{ getCalendarMonthLabel() }}</h3>
        </div>
        <div class="calendar-header">
          <button type="button" class="btn btn-calendar-nav" (click)="prevMonth()" aria-label="Previous month">
            <fa-icon [icon]="faIcons.chevronLeft"></fa-icon>
          </button>
          <span class="calendar-month-label">{{ getCalendarMonthLabel() }}</span>
          <button type="button" class="btn btn-calendar-nav" (click)="nextMonth()" aria-label="Next month">
            <fa-icon [icon]="faIcons.chevronRight"></fa-icon>
          </button>
        </div>
        <div class="calendar-grid">
          <div class="calendar-weekdays">
            <span *ngFor="let d of ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']" class="calendar-weekday">{{ d }}</span>
          </div>
          <div class="calendar-days" *ngIf="eventsByDate$ | async as eventsByDate">
            <ng-container *ngIf="(googleEventsByDate$ | async) as googleEventsByDate">
              <ng-container *ngIf="(conflicts$ | async) as conflicts">
                <div *ngFor="let day of getCalendarDays(); trackBy: trackByDateKey"
                    class="calendar-day"
                    [class.calendar-day-other-month]="!day.isCurrentMonth"
                    [class.calendar-day-past]="day.isPast"
                    [class.calendar-day-clickable]="(guild?.organizer || guild?.owner) && day.isCurrentMonth && !day.isPast"
                    (click)="day.isCurrentMonth && !day.isPast && !$event.target.closest('a') && !$event.target.closest('.calendar-event-google') && onDayClick(day.dateKey)">
                  <span class="calendar-day-num">{{ day.date.getDate() }}</span>
                  <div class="calendar-day-events">
                    <a *ngFor="let event of (eventsByDate[day.dateKey] || [])"
                      class="calendar-event-chip"
                      [class.calendar-event-signed-up]="event.signed_up"
                      [class.calendar-event-not-signed-up]="!event.signed_up"
                      [class.calendar-event-conflict]="hasConflict(event, conflicts)"
                      [href]="'https://discord.com/channels/' + guildId + '/' + event.channel_id + '/' + event.message_id"
                      target="_blank"
                      (click)="$event.stopPropagation()">
                      <span class="calendar-event-title">{{ truncateTitle(event.title) }}</span>
                      <span class="calendar-event-time">{{ getEventTime(event) }}</span>
                      <span *ngIf="hasConflict(event, conflicts)" class="conflict-badge" [matTooltip]="getConflictList(event, conflicts)">
                        <mat-icon class="conflict-icon">warning</mat-icon>
                      </span>
                    </a>
                    <span *ngFor="let gcal of (googleEventsByDate[day.dateKey] || [])"
                      class="calendar-event-chip calendar-event-google">
                      <span class="calendar-event-title">{{ truncateTitle(gcal.title) }}</span>
                      <span class="calendar-event-time">{{ getGoogleEventTime(gcal) }}</span>
                    </span>
              </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Non-Premium Users - Show Premium Feature Card -->
    <div *ngIf="!guild || !guild?.has_premium" class="premium-feature-card">
      <div class="premium-feature-content">
        <mat-icon class="premium-icon">workspace_premium</mat-icon>
        <h3 class="premium-title">Premium Feature</h3>
        <p class="premium-description">
          Upgrade to Premium to view and manage your upcoming events from the dashboard.
        </p>
        <button mat-raised-button color="primary" class="premium-button" (click)="navigateToPremium()">
          <mat-icon>workspace_premium</mat-icon>
          Upgrade to Premium
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultCount>
  <mat-card-content>0</mat-card-content>
</ng-template>
